;(function () {
  'use strict'

  document.addEventListener('guday:atc:updated', function (event) {
    var cart = event.detail && event.detail.cart
    if (!cart) return
    try {
      if (
        window.sharedFunctions &&
        typeof window.sharedFunctions.updateSidebarCart === 'function'
      ) {
        window.sharedFunctions.updateSidebarCart(cart)
      }
    } catch (e) {}
  })
})()
